// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iMm6Ng10{text-align:center;background-color:blue}`, "",{"version":3,"sources":["webpack://./src/client/pages/contact/styles.scss"],"names":[],"mappings":"AAAA,UACE,iBAAA,CACA,qBAAA","sourcesContent":[".contact {\n  text-align: center;\n  background-color: blue;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contact": `iMm6Ng10`
};
export default ___CSS_LOADER_EXPORT___;
